import { Box, Typography, useTheme } from '@mui/material';
import { lighten } from '@mui/material/styles';
import * as echarts from 'echarts';
import ReactECharts from 'echarts-for-react';
import 'echarts/lib/chart/map';
import React, { useEffect, useState } from 'react';

interface IRegionChartProps {
    title: string;
    data: { value: number; name: string }[];
}
type EChartOption = echarts.EChartsOption;
const RegionChart: React.FC<IRegionChartProps> = ({ title, data }) => {
    const theme = useTheme();
    const [chartOption, setChartOption] = useState<EChartOption | null>(null);

    useEffect(() => {
        const svgPath = '/assets/vn.svg';

        fetch(svgPath)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        'Network response was not ok ' + response.statusText
                    );
                }
                return response.text();
            })
            .then((svg) => {
                echarts.registerMap('Vietnam', { svg: svg });
                const option = {
                    tooltip: {
                        trigger: 'item',
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        formatter: function (params: any) {
                            return `${params.name}: ${params?.data?.value ?? 0}`;
                        },
                    },
                    series: [
                        {
                            name: 'Population',
                            type: 'map',
                            map: 'Vietnam',
                            emphasis: {
                                label: {
                                    show: false,
                                    color: '#ffffff',
                                },
                                itemStyle: {
                                    areaColor: theme.palette.primary.main,
                                },
                            },
                            itemStyle: {
                                areaColor: lighten(
                                    theme.palette.primary.main,
                                    0.72
                                ),
                                borderColor: '#000',
                            },
                            layoutCenter: ['30%', '50%'],
                            layoutSize: '130%',
                            data: data.map((item) => ({
                                name: item.name,
                                value: item.value ?? 0,
                            })),
                        },
                    ],
                };

                setChartOption(option as EChartOption);
            })
            .catch((error) => {
                console.error('Error loading SVG:', error);
            });
    }, [data]);

    return (
        <Box sx={{ display: 'flex', gap: 2 }}>
            {/* Map */}
            <Box sx={{ flex: 2 }}>
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: '28px',
                        textAlign: 'left',
                        lineHeight: '33.89px',
                        mb: 2,
                    }}
                >
                    {title}
                </Typography>
                {chartOption && <ReactECharts option={chartOption} notMerge />}
            </Box>

            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >
                {data.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #E0E0E0',
                            mb: 1,
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                            }}
                        >
                            {item.name}:
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ fontWeight: 600, fontSize: '14px' }}
                        >
                            {item.value ?? 0}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default RegionChart;
